import { http } from "./http";
import type { HeroBannerView } from "./heroBannerAdmin.api";

export const heroBannerApi = {
  async listBanners(hospId: number): Promise<HeroBannerView[]> {
    const res = await http.get(`/customer/hero-banners?hospId=${hospId}`);
    return res.data;
  },
};
